'use client';
import { useGSAP } from '@gsap/react';
import { Box, Center, Text } from '@chakra-ui/react';

import { rulesAnimation } from 'shared/gsap';
import BlockShadow from 'shared/BlockShadow';
import NextImage from 'shared/NextImage';

import { SECTIONS_IDS } from 'constants/global';
import BgView from 'assets/illustrations/rules/bgView.webp';
import TopView from 'assets/illustrations/rules/topView.webp';
import BottomView from 'assets/illustrations/rules/bottomView.webp';

const Rules = () => {
  useGSAP(rulesAnimation);

  return (
    <Center
      as="section"
      id={SECTIONS_IDS.rules}
      w="full"
      h={{ mobile: '590px', tablet: 'clamp(470px, 63vw, 620px)', laptop: '905px' }}
      alignItems="start"
      pos="relative"
      overflow="hidden"
    >
      <BlockShadow
        position="top"
        h={{ mobile: '16px', tablet: '28px', laptop: '50px' }}
        zIndex="3"
      />

      <Box w="full" pos="absolute" top="0" left="0" zIndex="2">
        <NextImage src={TopView} alt="Верхняя часть лобового стекла" w="full" h="full" />
      </Box>

      <Box
        id="rules-road-bg"
        w="full"
        minW={{ mobile: '656px', tablet: 'unset' }}
        pos="absolute"
        bottom={{
          mobile: '27%',
          tablet: 'clamp(165px, 24vw, 245px)',
          laptop: '29%',
          xxxl: '36%',
          preDesktop: '39%',
        }}
        left={{ mobile: 'calc(50% - (656px / 2))', tablet: '0' }}
        zIndex="1"
      >
        <NextImage src={BgView} alt="Дорога" w="full" h="full" />
      </Box>

      {/* TODO: Заменить верстку на Grid: stack из Experience */}
      <Text
        as="h2"
        id="rules-main-text"
        pos="absolute"
        zIndex="4"
        w="full"
        maxW={{ mobile: '345px', tablet: '530px', laptop: '800px' }}
        top={{ mobile: '93px', tablet: '75px', laptop: '150px' }}
        left={{
          mobile: 'calc(50% - (345px / 2))',
          tablet: 'calc(50% - (530px / 2))',
          laptop: 'calc(50% - (800px / 2))',
        }}
        textAlign="center"
        textTransform="uppercase"
      >
        Будь тем, кто задаёт правила игры
      </Text>

      <Text
        id="rules-subtext"
        pos="absolute"
        zIndex="4"
        w="full"
        maxW={{ mobile: '345px', tablet: '600px', laptop: '920px' }}
        top={{ mobile: '93px', tablet: '75px', laptop: '150px' }}
        left={{
          mobile: 'calc(50% - (345px / 2))',
          tablet: 'calc(50% - (600px / 2))',
          laptop: 'calc(50% - (920px / 2))',
        }}
        textAlign="center"
        textStyle="h5"
        opacity="0"
      >
        Ты в ИТ или на его пороге, но роль исполнителя уже не для тебя. Пора мыслить и действовать
        как руководитель
      </Text>

      <Box
        w="full"
        minW={{ mobile: '656px', tablet: 'unset' }}
        pos="absolute"
        bottom="0"
        left={{ mobile: 'calc(50% - (656px / 2))', tablet: '0' }}
        zIndex="2"
      >
        <NextImage src={BottomView} alt="Нижняя часть лобового стекла" w="full" h="full" />
      </Box>

      <BlockShadow
        position="bottom"
        h={{ mobile: '60px', tablet: '26px', laptop: '150px' }}
        zIndex="3"
      />
    </Center>
  );
};

export default Rules;
